module.exports = __webpack_public_path__ + "img/1855.7305a8da.gif";